import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../common/AutoBindComponent";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";
import * as types from "../../constants/ComponentConstants";
import * as bovenLokaliteitPerInfrastructuurActions from "../../actions/bovenLokaliteitPerInfrastructuurActions";
import * as layoutActions from "../../actions/layoutActions";
import * as beads from "../../actions/beadActions";

import InfrastructuurInDeBuurtDetailForm from "./InfrastructuurInDeBuurtDetailForm";
import InfrastructuurInDeBuurtDetailPageHelper from "./InfrastructuurInDeBuurtDetailPageHelper";

import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";

class InfrastructuurInDeBuurtDetailPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

        this.pageHelper = new InfrastructuurInDeBuurtDetailPageHelper(this);
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    handleOnChange(event, data) {
        this.pageHelper.change(event, data);
    }

    handleOnSave(event) {
        this.pageHelper.save(event);
    }

    handleOnCancel(event) {
        this.pageHelper.cancel(event);
    }

    handleOnReplacePoint(event) {
        this.pageHelper.replacePoint(event);
    }

    handleOnSaveNewPoint() {
        this.pageHelper.saveNewPoint();
    }

    handleOnCancelReplace() {
        this.pageHelper.cancelReplace();
    }

    handleOnGetGeoCoordinates(event) {
        this.pageHelper.getGeoCoordinates(event);
    }

    handleOnDragEnd(e) {
        this.pageHelper.onDragEnd(e);
    }

    render() {
        if (!this.pageHelper.isReadyToRender())
            return null;

        const {
            geoToolboxUrl,
            maxMapFeaturesToLoad,
            osmBaseLayerUrl
        } = this.props;

        return (<InfrastructuurInDeBuurtDetailForm
            color={types.COLOR_PINK}
            model={this.state.model}
            isNew={this.props.isNew}
            isSpakki={this.state.isSpakki}
            onChange={this.handleOnChange}
            soortenInfrastructuur={this.props.soortenInfrastructuur}
            gemeenten={this.props.gemeenten}
            postcodes={this.props.postcodes}
            mapKey={this.state.mapKey}
            mapEditMode={this.state.mapEditMode}
            mapCenter={this.state.mapCenter}
            mapNewCoords={this.state.mapNewCoords}
            onSave={this.handleOnSave}
            onCancel={this.handleOnCancel}
            onReplacePoint={this.handleOnReplacePoint}
            onSaveNewPoint={this.handleOnSaveNewPoint}
            onCancelReplace={this.handleOnCancelReplace}
            onGetGeoCoordinates={this.handleOnGetGeoCoordinates}
            errors={this.props.infrastructuurInDeBuurtErrors}
            geoToolboxUrl={geoToolboxUrl}
            maxMapFeaturesToLoad={maxMapFeaturesToLoad}
            osmBaseLayerUrl={osmBaseLayerUrl}
            onMarkerDragEnd={this.handleOnDragEnd}
        />);
    }
}

InfrastructuurInDeBuurtDetailPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
    const dossierId = ownProps.params.dossierId;
    const isNew = ownProps.route.params.isNew;
    const index = ownProps.routeParams.index;
    const soortenInfrastructuur = !(state.bovenLokaliteitPerInfrastructuur.item && (state.bovenLokaliteitPerInfrastructuur.item.andereInfrastructurenBeschikbaar === true || state.bovenLokaliteitPerInfrastructuur.item.andereInfrastructurenBeschikbaar === "true")) ? state.referentie.soortenInfrastructuur.filter((x, i) => i > 0) : state.referentie.soortenInfrastructuur;

    return {
        dossierId: dossierId,
        postcodes: convertToLabelValuePair(state.referentie.postcodes),
        gemeenten: convertToLabelValuePair(state.referentie.gemeenten),
        soortenInfrastructuur: soortenInfrastructuur,
        bovenLokaliteitPerInfrastructuur: state.bovenLokaliteitPerInfrastructuur,
        documenten: state.bovenLokaliteitPerInfrastructuur.documenten,
        fileSessionStarted: state.bovenLokaliteitPerInfrastructuur.fileSessionStarted,
        index: index,
        sportinfrastructurenInDeBuurt: state.bovenLokaliteitPerInfrastructuur.item.sportinfrastructurenInDeBuurt,
        infrastructuurInDeBuurtErrors: state.bovenLokaliteitPerInfrastructuur.infrastructuurInDeBuurtErrors,
        validationMessageType: state.bovenLokaliteitPerInfrastructuur.validationMessageType,
        isNew: isNew,
        infrastructuurCoords: Object.assign({}, { lat: parseFloat(state.bovenLokaliteitPerInfrastructuur.item.breedtegraad), lng: parseFloat(state.bovenLokaliteitPerInfrastructuur.item.lengtegraad) }),
        geoToolboxUrl: state.settings.geoToolboxUrl,
        maxMapFeaturesToLoad: state.settings.maxMapFeaturesToLoad,
        osmBaseLayerUrl: state.settings.osmBaseLayerUrl
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadInfrastructuurDetailPageLayout, dispatch),
        beadsLoaded: bindActionCreators(beads.beadsLoaded, dispatch),
        getEmptySportInfrastructuurInDeBuurt: bindActionCreators(bovenLokaliteitPerInfrastructuurActions.getEmptySportinfrastructuurInDeBuurt, dispatch),
        saveBovenLokaliteitPerInfrastructuur: bindActionCreators(bovenLokaliteitPerInfrastructuurActions.saveBovenLokaliteitPerInfrastructuurCache, dispatch),
        resetInfrastructuurErrors: bindActionCreators(bovenLokaliteitPerInfrastructuurActions.resetInfrastructuurErrors, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(InfrastructuurInDeBuurtDetailPage));